<template>
  <section class="footer has-background-white py-0">
    <!--<div class="is-hidden-touch">
      <div class="container">
        <div class="level">
          <span class="level-left">
            <img
              src="@/assets/mSchoolsFooter@2x.png"
              style="object-fit: cover; width:160px;height:35px;"
            >
          </span>
          <div class="buttons level-right">
            <app-social-networks color="#4A90E2"></app-social-networks>
          </div>
        </div>
        <div
          class="columns is-centered link-columns"
          style="padding-bottom:55px; padding-top:50px;"
        >
          <app-network-column
            :inFooter="true"
            v-for="(column,index) in networkColumns"
            bordercolor="#f2f2f2"
            :title="column.title"
            :links="column.links"
            :key="index"
            :data-index="index"
            :class="{'is-narrow':index==networkColumns.length-1}"
          ></app-network-column>
        </div>
      </div>
    </div>
    <hr v-if="showLogos">-->
    <div class="columns" style="padding-top:20px;margin-bottom:0px" v-if="showLogos">
      <div class="column has-text-left" style="margin-left:12px">
        <p class="has-text-weight-semibold" v-t="`Footer.initiative`"></p>
        <img
          src="@/assets/logo_mobile_world_capital.png"
          style="object-fit: cover; padding-top:10px;"
        >
      </div>
      <div class="column">
        <p
          class="has-text-left is-hidden-mobile has-text-weight-semibold"
          v-t="`Footer.partnership`"
        ></p>
        <div class="level is-hidden-mobile is-7">
          <div class="column is-paddingless">
            <img
              src="@/assets/logo_generalitat.png"
              class="is-pulled-left"
              style="object-fit: cover;"
            >
          </div>
          <div class="column">
            <img src="@/assets/logo_ajuntament.png" style="object-fit: cover;">
          </div>
          <div class="column">
            <img src="@/assets/logo_gsma.png" style="object-fit: cover;">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppNetworkColumn from './AppNetworkColumn'
import AppSocialNetworks from './AppSocialNetworks'
import axios from 'axios'
export default {
  components: {
    AppNetworkColumn,
    AppSocialNetworks
  },

  mounted () {
    /*axios.get('https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=json').then(result => {
      this.ip = result.data.ip
      axios.get('https://cors-anywhere.herokuapp.com/http://www.geoplugin.net/json.gp?ip=' + result.data.ip).then(geoip => {
        this.country = geoip.data.geoplugin_countryCode
      })
    })*/
  },
  data () {
    return {
      ip: undefined,
      country: undefined,
      networkColumns: [
        {
          title: 'educate',
          links: [
            {
              name: 'app_education',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/app-education/'
            },
            {
              name: 'scratch_challenge',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/scratch-challenge/'
            },
            { name: 'msteam', url: '' }
          ]
        },
        {
          title: 'transform',
          links: [
            {
              name: 'eduhack',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/edu_hack/'
            },
            {
              name: 'changing_education',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/changing-education-together/'
            }
          ]
        },
        {
          title: 'collaborate',
          links: [
            {
              name: 'toolbox',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mschools-toolbox/'
            },
            {
              name: 'mobile_history_map',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mobile-history-map/'
            },
            { name: 'experts', url: 'http://experts.mobileworldcapital.com/' }
          ]
        },
        {
          title: 'compete',
          links: [
            // { name: 'sdg_challenge', url: 'http://sdg.mschools.com' },
            {
              name: 'student_awards',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mschools-student-awards/'
            },
            {
              name: 'mobile_learning_awards',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mobile-learning-awards/'
            },
            {
              name: 'techcamp',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mschools-techcamp/'
            },
            {
              name: 'yomo',
              url: 'http://mschools.mobileworldcapital.com/mschools-yomo/'
            }
          ]
        },
        {
          title: 'stay_tuned',
          links: [
            {
              name: 'agenda',
              url: 'http://mschools.mobileworldcapital.com/agenda-and-events/'
            },
            {
              name: 'blog',
              url: 'http://mschools.mobileworldcapital.com/news-picks/'
            },
            {
              name: 'about',
              url: 'http://mschools.mobileworldcapital.com/what-is-mschools/'
            },
            {
              name: 'newsletter',
              url: 'http://mschools.mobileworldcapital.com/newsletter/'
            },
            {
              name: 'contact',
              url: 'http://mschools.mobileworldcapital.com/contact/'
            }
          ]
        }
      ]
    }
  },
  computed: {
    showLogos () {
      //return this.country === 'ES'
      return true;
    }
  }
}
</script>

<style scoped lang="scss">
.column {
  img {
    max-width: 80%;
  }
}
li:first-child {
  margin-top: 25px;
}
section {
  padding-bottom: 25px !important;
}
.link-columns .column:last-child {
  border-right: 1px solid #f2f2f2 !important;
  padding-right: 40px;
}
.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
</style>

<style lang="sass" scoped>
.menu-list
  a
    &:hover
      background-color: #03273b
      color: white
    &.is-active
</style>
